import React from "react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const Header = (props) => {
  const [headerRef, isHeaderVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <div className="p-4 sm:px-6 lg:px-8 py-8 mt-12">
      <div 
        ref={headerRef}
        className={`bg-white rounded-[20px] p-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform ${
          isHeaderVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12">
            {/* Left Content */}
            <div className="w-full md:w-1/2 text-center md:text-left">
              <h1 className="font-nunito text-4xl md:text-6xl font-bold text-black mb-4 leading-tight">
                Fleet electrification
              </h1>
              <h3 className="font-nunito text-2xl md:text-3xl text-gray-600 mb-6">
                made easy
              </h3>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed font-nunito">
                {props.data ? props.data.paragraph : "Loading"}
              </p>
              
              {/* Call-to-action Button */}
              <div className="pt-4">
                <Link 
                  to="/login?mode=register" 
                  className="btn-primary btn-lg"
                >
                  Register Now
                </Link>
              </div>
            </div>
            
            {/* Right Content */}
            <div className="w-full md:w-1/2">
              <img 
                className="w-full h-auto max-w-lg mx-auto rounded-lg" 
                src='img/homepage/homepage-truck.png' 
                alt="homepage-truck" 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
